import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';
import simpleParallax from 'simple-parallax-js';

jQuery(document).ready(function($){
    const homeParallax = () => {
        create({
            player: "#heroAnimation",
            mode:"scroll",
            container: "#heroContainer",
            actions: [
                {
                    visibility: [0.5, 1],
                    type: 'seek',
                    frames: [0, 18],
                },
            ]
        });
    }

    if ( $('.service-card__image').length > 0 ) {
        var images = document.querySelectorAll('.service-card__image');
        new simpleParallax(images, {
            delay: 0,
            orientation: 'up',
            scale: 1.3,
            overflow: true,
        });
    }
});